import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const MedalliaRedux = createActions(
  {
    MedalliaRequest: ['start_date', 'end_date','type_quiz'],
    MedalliaSuccess: ['data', 'fileName'],
    MedalliaError: ['error'],
    CentersMedalliaRequest: ['start_date', 'end_date', 'centerId'],
    CentersMedalliaSuccess: ['data', 'fileName'],
    CentersMedalliaError: ['error'],
  },
  {
    prefix: 'MEDALLIA_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = MedalliaRedux
export const MedalliaTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

/* ------------- Reducers ------------- */

const MedalliaRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const MedalliaSuccess = (state, { data, fileName }) => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  data: { file: data, fileName }
}, d)
const MedalliaError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

const CentersMedalliaRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const CentersMedalliaSuccess = (state, { data, fileName }) => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  data: { file: data, fileName }
}, d)
const CentersMedalliaError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)


export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.MedalliaRequest]: MedalliaRequest,
    [Types.MedalliaSuccess]: MedalliaSuccess,
    [Types.MedalliaError]: MedalliaError,
    [Types.CentersMedalliaRequest]: CentersMedalliaRequest,
    [Types.CentersMedalliaSuccess]: CentersMedalliaSuccess,
    [Types.CentersMedalliaError]: CentersMedalliaError,
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/MedalliaRedux.js